import FileUpload from "@components/Shared/FileUpload";
import FormTextField from "@components/Shared/FormTextField";
import { useState } from "react";
import { Field } from "react-final-form";
import styles from "./BoxUrlOrFile.module.scss";

interface IBoxUrlOrFileProps {
  title?: string;
  initialValueUrl?: string;
  section?: "create" | "modify";
  initialData?: any;
  formFieldName?: string;
}

const BoxUrlOrFile = ({
  title,
  initialValueUrl,
  section = "create",
  initialData,
  formFieldName = "mediaUrl",
}: IBoxUrlOrFileProps) => {
  const [selectedOption, setSelectedOption] = useState("url");

  return (
    <div className={`${styles.boxUrlOrFile} form__form-group`}>
      <div className={`${styles.container} ${!title ? styles.noTitle : ""}`}>
        <fieldset className={styles.radioSection}>
          {title && <span className={styles.label}>{title}</span>}

          <div className={styles.radioGroup}>
            <div className={styles.radioAndLabel}>
              <input
                type="radio"
                id="urlOrFile1"
                name="urlOrFile"
                value="url"
                checked={selectedOption === "url"}
                onChange={(e) => setSelectedOption(e.target.value)}
              />
              <label htmlFor="urlOrFile1">Embed URL</label>
            </div>

            <div className={styles.radioAndLabel}>
              <input
                type="radio"
                id="urlOrFile2"
                name="urlOrFile"
                value="file"
                checked={selectedOption === "file"}
                onChange={(e) => setSelectedOption(e.target.value)}
              />
              <label htmlFor="urlOrFile2">Upload File</label>
            </div>
          </div>
        </fieldset>

        {selectedOption === "url" ? (
          <div className={`${styles.urlSection} form__form-group-field`}>
            <Field
              name={formFieldName}
              component={FormTextField}
              type="text"
              placeholder={title ? `${title} URL` : "Enter URL"}
              isAboveError
              initialValue={initialValueUrl ?? undefined}
            />
          </div>
        ) : section === "create" ? (
          <FileUpload isSingle formFieldName={formFieldName} />
        ) : (
          <FileUpload
            isSingle
            initialData={initialData}
            formFieldName={formFieldName}
          />
        )}
      </div>
    </div>
  );
};

export default BoxUrlOrFile;
